import { checkHttpStatus, parseJSON, cacheBust } from '../utils';

import { loginUserSuccess, loginUserFailure, loginUserRequest } from './login'
import { setProject, setSubmit } from './status';
import { showMessage } from './message'
import { setUpload, failedUpload, beginUpload } from './upload'
import { setPayever, successPayever, pendingPayever, cancelPayever, failedPayever, setPendingOrder } from './payever'
import { doRelog, authRequest, authSuccess, authFailure } from './auth'
import { checkPayever, uncheckPayever, unknownErrorPayever } from './payever';

import { showLoading, hideLoading } from 'react-redux-loading-bar'

import { push } from 'react-router-redux';
import fetch from 'isomorphic-fetch';

import LocalStorageUtils from '../utils/LocalStorageUtils';

var AppConfig = require('../config.json');


export function doRefresh() {
    return (dispatch) => {
        dispatch(showLoading());
        return fetch(AppConfig.serviceUrl+'/refresh', {
            method: 'GET',
            headers: new Headers({
                'Accept': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Content-Type': 'application/json',
                'Token': LocalStorageUtils.token()
            })
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            LocalStorageUtils.doRefresh(response.data);
            dispatch(hideLoading());
            dispatch(push('/home'));
        })
        .catch(error => {
            dispatch(hideLoading());
            dispatch(showMessage('Die Aktualisierung ist fehlgeschlagen'));
        })
   }
}


export function uploadFile(uploadform, type, validDate) {
    return (dispatch) => {
        dispatch(showLoading());
        dispatch(beginUpload({type: type}));
        return fetch(AppConfig.uploadUrl, {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Token': LocalStorageUtils.token()
            }),
            body: uploadform
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            dispatch(hideLoading());
            dispatch(setUpload({path: response.data.path.absolute, type: type, validDate: validDate}));
        })
        .catch(error => {
            dispatch(hideLoading());
            dispatch(failedUpload());
            dispatch(showMessage('Ein Fehler ist aufgetreten.'));
        })
   }
}


export function getPayeverFrame(orderform) {
    return (dispatch) => {
        dispatch(showLoading());
        return fetch(AppConfig.payeverUrl+cacheBust(), {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Content-Type': 'application/json',
                'Token': LocalStorageUtils.token()
            }),
            body: JSON.stringify(orderform)
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            dispatch(hideLoading());
            if(response.hasOwnProperty('data') && response.data.result!=="error") {
                dispatch(setPayever(response.data));
            } else {
                dispatch(unknownErrorPayever());
                dispatch(showMessage('Ein unbekannter Fehler ist aufgetreten.'));
            }
            
        })
        .catch(error => {
            dispatch(hideLoading());
            dispatch(unknownErrorPayever());
            dispatch(showMessage('Ein Fehler ist aufgetreten.'));
        })
   }
}

export function checkPayeverStatus(form) {
    return (dispatch) => {
        return fetch(AppConfig.payeverUrl + cacheBust(), {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Token': LocalStorageUtils.token()
            }),
            body: JSON.stringify(form)
        })
            .then(checkHttpStatus)
            .then(parseJSON)
            .then(response => {
                if (response.hasOwnProperty('data')) {
                    if (response.data.result === "success" || response.data.result === "error" || response.data.result === "failure") {
                        dispatch(successPayever(response.data.details));
                    } else if (response.data.result === "pending") {
                        dispatch(pendingPayever(response.data.details));
                    } else if (response.data.result === "cancel") {
                        dispatch(cancelPayever());
                    } else {
                        dispatch(unknownErrorPayever());
                    }
                }
            })
            .catch(error => {
                dispatch(showMessage('Ein Fehler ist aufgetreten.'));
            })
    }
}


export function pendingOrder(orderform) {
    return (dispatch) => {
        dispatch(showLoading());
        return fetch(AppConfig.ordersUrl+cacheBust(), {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Content-Type': 'application/json',
                'Token': LocalStorageUtils.token()
            }),
            body: JSON.stringify(orderform)
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            dispatch(hideLoading());
            if(response.hasOwnProperty('data') && response.data.hasOwnProperty('orderId') && response.data.orderId>0) {
                dispatch(setPendingOrder({status:'success',msg:'', data: response.data}));
            } else {
                dispatch(setPendingOrder({status:'error',msg:'', data: {orderId:0}}));
                dispatch(showMessage('Ein Fehler ist aufgetreten.'));
            }
            
        })
        .catch(error => {
            dispatch(hideLoading());
            dispatch(setPendingOrder({status:'error',msg:'', data: {orderId:0}}));
            dispatch(showMessage('Ein Fehler ist aufgetreten.'));
        })
   }
}


export function submitOrder(orderform) {
    return (dispatch) => {
        dispatch(showLoading());
        return fetch(AppConfig.ordersUrl+cacheBust(), {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Content-Type': 'application/json',
                'Token': LocalStorageUtils.token()
            }),
            body: JSON.stringify(orderform)
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            dispatch(hideLoading());
            if(response.hasOwnProperty('data') && response.data.hasOwnProperty('id') && response.data.id>0) {
                dispatch(setSubmit({status:'success',msg:'', data: response.data}));
            } else {
                dispatch(setSubmit({status:'error',msg:response.data.msg, data: {}}));
                dispatch(showMessage('Ein Fehler ist aufgetreten.'));
            }
            
        })
        .catch(error => {
            dispatch(hideLoading());
            dispatch(setSubmit({status:'error',msg:'', data: {}}));
            dispatch(showMessage('Ein Fehler ist aufgetreten.'));
        })
   }
}



export function checkUserAuth() {
    return (dispatch) => {
        dispatch(showLoading());
        dispatch(authRequest());
        return fetch(AppConfig.serviceUrl+'/authorized', {
            method: 'GET',
            headers: new Headers({
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Token': LocalStorageUtils.token()
            })
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            dispatch(authSuccess(response.data));
            dispatch(hideLoading());
        })
        .catch(error => {
            dispatch(hideLoading());
            LocalStorageUtils.notAuthorized();
            dispatch(authFailure(error));
            dispatch(showMessage('Bitte loggen sie sich erneut ein'));
            dispatch(doRelog());
            dispatch(push('login'));
            
        })
   }
}

export function loginUser(username, password) {
    return function(dispatch) {
        dispatch(showLoading());
        dispatch(loginUserRequest());
        return fetch(AppConfig.serviceUrl+'/login', {
            method: 'GET',
            headers: new Headers({
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Realm': btoa(AppConfig.frontendKey),
                'Authorization': 'Basic '+btoa(username+':'+password)
            })
            
        })
        .then(checkHttpStatus)
            .then(parseJSON)
            .then(response => {
                dispatch(hideLoading());
                dispatch(setProject(response.data.project));
                dispatch(loginUserSuccess(response.data));
                
            })
            .catch(error => {
                dispatch(hideLoading());
                dispatch(loginUserFailure(error));
                dispatch(showMessage('Loginversuch fehlgeschlagen'));
                
            })
    }
}




// WEBPACK FOOTER //
// ./src/actions/index.js